import Blocks from '@component/Blocks';
import EntryIndex from '@component/EntryIndex';
import PageHeader from '@component/PageHeader';
import Box from '@componentPrimitives/Box';
import Container from '@componentPrimitives/Container';
import Grid from '@componentPrimitives/Grid';
import { EntryLinks } from '@components/PageHeader/EntryLinks';
import { useViewColorTheme } from '@lib/store';
import { useTranslations } from 'next-intl';

const ProfileIndex = () => {
  const t = useTranslations();
  const viewColorTheme = useViewColorTheme();

  return (
    <>
      <PageHeader />
      <EntryIndex indexKey="profileIndex">
        <Box colorTheme={viewColorTheme} colorSet="paper" paper cx={{ mB: 'xl' }}>
          <Container cx={{ pB: 'lg' }}>
            <Grid>
              <Grid.Col sm={6}>
                <EntryLinks />
              </Grid.Col>
              <Grid.Col sm={6} cx={{ textAlign: 'right' }}>
                <EntryIndex.Filters
                  items={[
                    {
                      categoryTypeId: 'profileCategory',
                      label: t('profileCategory.singularName'),
                    },
                  ]}
                />
              </Grid.Col>
              <Grid.Col>
                <EntryIndex.CategoryChips />
              </Grid.Col>
            </Grid>
          </Container>
        </Box>
        <Box paper cx={{ pB: 'xl' }}>
          <Container>
            <EntryIndex.ScrollTop />
            <EntryIndex.Grid />
            <EntryIndex.Pagination />
          </Container>
        </Box>
      </EntryIndex>
      <Blocks />
    </>
  );
};

export default ProfileIndex;
